export default __webpack_public_path__ + "static/media/Kaan-BG.d5be59ae.webp";